import { render } from "./TransportInvoices.vue?vue&type=template&id=3ec31510&scoped=true&ts=true"
import script from "./TransportInvoices.vue?vue&type=script&lang=ts"
export * from "./TransportInvoices.vue?vue&type=script&lang=ts"

import "./TransportInvoices.vue?vue&type=style&index=0&id=3ec31510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec31510"]])

export default __exports__